/**
 * Show feedback for the user inside input boxes of form.
 *
 * @param type
 * @param result
 */
function mas_form_recognition_premium_message_input(type = "", result = "") {
	result.removeClass( "forms__result--success" )
		.removeClass( "forms__result--error" )
		.removeClass( "forms__result--info" );
	let iconType;

	switch (type) {
		case "success":
			iconType = "icon-general-success";
			result.addClass( "forms__result--success" );
			break;
		case "error":
			iconType = "icon-general-fail";
			result.addClass( "forms__result--error" );
			break;
		default:
			iconType = "icon-general-info-black";
			result.addClass( "forms__result--info" );
			break;
	}

	const icon = jQuery( "<i>", { class: iconType } );
	result.empty().append( icon );
}

/**
 * Clears div classes and empties them.
 */
function mas_form_recognition_premium_message_general_clean() {
	const result = jQuery( ".forms__common-result" );
	result.removeClass( "forms__common-result--success" )
		.removeClass( "forms__common-result--error" )
		.removeClass( "forms__common-result--info" )
		.empty();
}

/**
 * Show feedback of general errors for the user in a text box.
 *
 * @param message
 * @param type
 */
function mas_form_recognition_premium_message_general(message = "", type = "") {
	const result    = jQuery( "#masRecognitionResult" );
	const paragraph = jQuery( "<p>", { text: message } );

	/**
	 * Builder result section
	 */
	let iconType;

	switch (type) {
		case "success":
			iconType = "icon-general-success";
			result.addClass( "forms__common-result--success" );
			paragraph.addClass( "js-form-success" );
			break;
		case "error":
			iconType = "icon-general-fail";
			result.addClass( "forms__common-result--error" );
			paragraph.addClass( "js-form-error" );
			break;
		default:
			iconType = "icon-general-info-black";
			result.addClass( "forms__common-result--info" );
			paragraph.addClass( "js-form-info" );
			break;
	}

	const icon = jQuery( "<i>", { class: iconType } );

	mas_form_recognition_premium_message_general_clean();
	result.append( icon, paragraph );
}

/**
 * Disable submit form button.
 */
function mas_form_recognition_premium_submit_disabled() {
	jQuery( "#masPremiumRecognitionSubmit" ).prop( "disabled", true );
}

/**
 * Enable submit form button.
 */
function mas_form_recognition_premium_submit_enabled() {
	jQuery( "#masPremiumRecognitionSubmit" ).prop( "disabled", false );
}

/**
 * Reset form fields and feedback icon.
 */
function mas_form_recognition_premium_reset() {
	jQuery( "#masPremiumRecognition" ).trigger( "reset" );
	jQuery( ".forms__result" ).empty();
	jQuery( "#masPremiumRecognitionOptions" ).select2( "destroy" ).select2(
		{
			placeholder: "¿Que reconocimiento necesita?",
		}
	);
}

/**
 * Send form to custom Recognition Premium ajax action.
 *
 * @param nif
 * @param company_name
 * @param postal
 * @param contact
 * @param phone
 * @param email
 * @param options
 * @param current_url
 * @param time
 * @param nonce
 * @param recognition_premium
 * @param token
 * @param checkbox
 */
function mas_form_recognition_premium_send(
	nif,
	company_name,
	postal,
	contact,
	phone,
	email,
	options,
	current_url,
	time,
	nonce,
	recognition_premium,
	token,
	checkbox
) {
	let myRequestURL = "/wp-admin/admin-ajax.php?timestamp=" + new Date().getTime();

	jQuery.ajax(
		{
			type: "POST",
			url: myRequestURL,
			data: {
				action: "mas_form_recognition_premium",
				data: {
					nif: nif.val(),
					company_name: company_name.val(),
					postal: postal.val(),
					contact: contact.val(),
					phone: phone.val(),
					email: email.val(),
					options: options.val(),
					current_url: current_url.val(),
					time: time.val(),
					nonce: nonce.val(),
					recognition_premium: recognition_premium.val(),
					token: token,
					checkbox: checkbox.is( ":checked" ),
				},
			},
			dataType: "json",
			crossDomain: true,
			cache: false,
			beforeSend: function () {
				mas_form_recognition_premium_submit_disabled();
				mas_form_recognition_premium_message_general(
					"Estamos procesando su solicitud. " +
					"Por favor, espere. Puede tardar varios segundos."
				);
			},
			success: function (data, textStatus, jqXHR) {
				mas_form_recognition_premium_submit_enabled();
				mas_form_recognition_premium_reset();
				if (200 !== jqXHR.status) {
					return;
				}
				mas_form_recognition_premium_message_general( data.message, "success" );
			},
			error: function (jqXHR) {
				mas_form_recognition_premium_submit_enabled();
				mas_form_recognition_premium_reset();
				const response = JSON.parse( jqXHR.responseText );
				mas_form_recognition_premium_message_general( response.message, "error" );
			},
		}
	);
}

/**
 * Validate specific fields before sending.
 *
 * @param nif
 * @param name
 * @param postal
 * @param contact
 * @param phone
 * @param email
 * @param options
 * @param url
 *
 * @returns {boolean}
 */
function mas_form_recognition_premium_validate_premium(
	nif,
	name,
	postal,
	contact,
	phone,
	email,
	options,
	url
) {
	let isError = false;

	/**
	 * NIF field validation
	 */
	const domResultNif = jQuery( '.forms__result[data-field="' + nif.attr( "id" ) + '"]' );
	if (9 !== nif.val().length) {
		mas_form_recognition_premium_message_input( "error", domResultNif );
		isError = true;
	} else {
		mas_form_recognition_premium_message_input( "success", domResultNif );
	}

	/**
	 * COMPANY NAME field validation
	 */
	const domResultCompanyName = jQuery(
		'.forms__result[data-field="' + name.attr( "id" ) + '"]'
	);
	if (0 === name.val().length) {
		mas_form_recognition_premium_message_input( "error", domResultCompanyName );
		isError = true;
	} else {
		mas_form_recognition_premium_message_input( "success", domResultCompanyName );
	}

	/**
	 * POSTAL field validation
	 */
	const domResultPostal = jQuery(
		'.forms__result[data-field="' + postal.attr( "id" ) + '"]'
	);
	if ( ! /^(?:0?[1-9]|[1-4]\d|5[0-2])\d{3}$/.test( postal.val() )) {
		mas_form_recognition_premium_message_input( "error", domResultPostal );
		isError = true;
	} else {
		mas_form_recognition_premium_message_input( "success", domResultPostal );
	}

	/**
	 * CONTACT field validation
	 */
	const domResultContact = jQuery(
		'.forms__result[data-field="' + contact.attr( "id" ) + '"]'
	);
	if (0 === contact.val().length) {
		mas_form_recognition_premium_message_input( "error", domResultContact );
		isError = true;
	} else {
		mas_form_recognition_premium_message_input( "success", domResultContact );
	}

	/**
	 * PHONE field validation
	 */
	const domResultPhone = jQuery(
		'.forms__result[data-field="' + phone.attr( "id" ) + '"]'
	);
	if ( ! /^\d{9}$/.test( phone.val() )) {
		mas_form_recognition_premium_message_input( "error", domResultPhone );
		isError = true;
	} else {
		mas_form_recognition_premium_message_input( "success", domResultPhone );
	}

	/**
	 * EMAIL field validation
	 */
	const domResultEmail = jQuery(
		'.forms__result[data-field="' + email.attr( "id" ) + '"]'
	);
	if ( ! /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test( email.val() )) {
		mas_form_recognition_premium_message_input( "error", domResultEmail );
		isError = true;
	} else {
		mas_form_recognition_premium_message_input( "success", domResultEmail );
	}

	/**
	 * OPTIONS field validation
	 */
	const domResultOptions = jQuery(
		'.forms__result[data-field="masPremiumRecognitionOptions"]'
	);
	if (0 === options.val().length) {
		mas_form_recognition_premium_message_input( "error", domResultOptions );
		isError = true;
	} else {
		mas_form_recognition_premium_message_input( "success", domResultOptions );
	}

	/**
	 * URL field validation
	 */
	const domResultUrl = jQuery(
		'.forms__result[data-field="' + url.attr( "id" ) + '"]'
	);
	if (0 === url.val().length) {
		mas_form_recognition_premium_message_input( "error", domResultUrl );
		isError = true;
	} else {
		mas_form_recognition_premium_message_input( "success", domResultUrl );
	}

	return true !== isError;
}

/**
 * Validate security fields before sending.
 *
 * @param time
 * @param nonce
 * @param recognition_premium
 *
 * @returns {boolean}
 */
function mas_form_recognition_premium_validate_security(time, nonce, recognition_premium) {
	if (0 === time.val().length) {
		return false;
	}
	if (0 === nonce.val().length) {
		return false;
	}
	if (0 < recognition_premium.val().length) {
		return false;
	}

	return true;
}

/**
 * Validate checkbox field before sending.
 *
 * @param checkbox
 *
 * @returns {boolean}
 */
function mas_form_recognition_premium_validate_checkbox(checkbox) {
	if (false === checkbox.is( ":checked" )) {
		return false;
	}

	return true;
}

/**
 * Handle submit custom Recognition Premium form.
 */
function mas_form_recognition_premium_initialize_premium() {
	const form = jQuery( "#masPremiumRecognition" );
	form.on(
		"submit",
		function (event) {
			event.preventDefault();

			const nif                 = jQuery( "#masPremiumRecognitionNif" );
			const company_name        = jQuery( "#masPremiumRecognitionCompanyName" );
			const postal              = jQuery( "#masPremiumRecognitionZip" );
			const contact             = jQuery( "#masPremiumRecognitionContactPerson" );
			const phone               = jQuery( "#masPremiumRecognitionContactPhone" );
			const email               = jQuery( "#masPremiumRecognitionContactEmail" );
			const options             = jQuery( "#masPremiumRecognitionOptions" );
			const current_url         = jQuery( "#masPremiumRecognitionUrl" );
			const time                = jQuery( "#masPremiumRecognitionTime" );
			const nonce               = jQuery( "#masPremiumRecognitionNonce" );
			const premium_recognition = jQuery( "#masPremiumRecognition" );
			const key                 = jQuery( "#masFormPublicKey" );
			const checkbox            = jQuery( "#masPremiumRecognitionLegalCheckbox" );

			if ( false === mas_form_recognition_premium_validate_premium(
				nif,
				company_name,
				postal,
				contact,
				phone,
				email,
				options,
				current_url
			) ) {
				mas_form_recognition_premium_message_general(
					"¡Ups! Revise alguno de los campos.",
					"error"
				);
				return false;
			}

			if (false === mas_form_recognition_premium_validate_security(
				time,
				nonce,
				premium_recognition
			)) {
				mas_form_recognition_premium_message_general(
					"¡Ups! Algo no ha ido bien. Refresque la página y pruebe de nuevo.",
					"error"
				);
				return false;
			}

			if (false === mas_form_recognition_premium_validate_checkbox( checkbox )) {
				mas_form_recognition_premium_message_general(
					"¡Ups! Acepte la casilla de la política de privacidad.",
					"error"
				);
				return false;
			}

			grecaptcha.ready(
				function () {
					grecaptcha.execute( key.val(), { action: 'submit' } ).then(
						function (token) {
							if (0 === token.length) {
								mas_form_recognition_premium_message_general(
									"¡Ups! Algo no ha ido bien." +
									" Refresque la página y pruebe de nuevo.",
									"error"
								);
								return false;
							}

							mas_form_recognition_premium_send(
								nif,
								company_name,
								postal,
								contact,
								phone,
								email,
								options,
								current_url,
								time,
								nonce,
								premium_recognition,
								token,
								checkbox
							);

							return true;
						}
					);
				}
			);

			return true;
		}
	);
}

(function ($) {
	$( document ).ready(
		function () {
			/**
			 * Initialize Select2
			 */
			jQuery( "#masPremiumRecognitionOptions" ).select2(
				{
					placeholder: "¿Que reconocimiento necesita?",
				}
			);

			jQuery( window ).resize(
				function () {
					let domSelect = jQuery( "#masPremiumRecognitionOptions" );
					domSelect.select2( "destroy" );
					domSelect.select2(
						{
							placeholder: "¿Que reconocimiento necesita?",
						}
					);
				}
			);

			mas_form_recognition_premium_initialize_premium();
		}
	);
})( jQuery );
